import { useParams, useLocation } from "react-router-dom";

import Wrapper from ".";

export const PublicWrapper = (props) => {
    const params = useParams();
    const location = useLocation();
        
    return (
        <Wrapper {...props} location={location} params={params} />
    );
}

export default PublicWrapper;